import { render, staticRenderFns } from "./icon-with-text-b1.vue?vue&type=template&id=57d47ab0&scoped=true&"
import script from "./icon-with-text-b1.vue?vue&type=script&lang=js&"
export * from "./icon-with-text-b1.vue?vue&type=script&lang=js&"
import style0 from "./icon-with-text-b1.vue?vue&type=style&index=0&id=57d47ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d47ab0",
  null
  
)

export default component.exports